import { styled } from '@mui/material';
import { BUDGET, DECISION } from 'business/constants';
import NotFound from 'components/Errors/NotFound';
import Loading from 'components/Loading';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useGetClient } from 'routes/Support/hooks/getClient';
import Flex from 'ui/Flex/Flex';
import TabulatedPage from 'ui/TabulatedPage/TabulatedPage';
import SupportHeader from '../SupportHeader/SupportHeader';
import ClientConfiguration from './components/ClientConfiguration/ClientConfiguration';
import DecisionConfiguration from './components/DecisionConfiguration/DecisionConfiguration';
import MappingAndScopes from './components/MappingAndScopes/MappingAndScopes';
import BudgetConfiguration from 'routes/Support/components/ClientSupport/components/BudgetConfiguration/BudgetConfiguration';

export const DEFAULT_TAB = 'configuration';

const StyTabulatedPage = styled(TabulatedPage, {
    name: 'StyTabulatedPage',
})({
    height: 'calc(100% - 78px)',
    '& .Mui-TabulatedPage-content-div': {
        overflowY: 'auto',
        height: 'calc(100% - 39px)',
    },
});

const ClientSupport = () => {
    const { t } = useTranslation();
    const { bind } = useParams();

    const { data: client, isLoading, error } = useGetClient(bind);
    if (error) {
        return <NotFound />;
    }
    if (isLoading || !client) {
        return <Loading />;
    }
    const tabsList = [
        {
            label: t('support.configuration.core'),
            children: <ClientConfiguration client={client} />,
            pathname: `/support/${bind}/${DEFAULT_TAB}`,
            disabled: false,
        },
        {
            label: t('support.perimeters'),
            children: <MappingAndScopes bind={client.bind} />,
            pathname: `/support/${bind}/perimeters`,
            disabled: false,
        },
        {
            label: t('support.configuration.decision'),
            children: <DecisionConfiguration client={client} />,
            pathname: `/support/${bind}/decision`,
            disabled: !client.modules.includes(DECISION),
        },
        {
            label: t('support.configuration.budget'),
            children: <BudgetConfiguration bind={client.bind} />,
            pathname: `/support/${bind}/budget`,
            disabled: !client.modules.includes(BUDGET),
        },
    ];
    return (
        <Flex className="page-container" direction="column">
            <SupportHeader bind={client.name} />
            <StyTabulatedPage tabsList={tabsList} />
        </Flex>
    );
};

export default React.memo(ClientSupport);
